export function addDays(date, numDays) {
  let newDate = new Date(date.getTime());
  newDate.setDate(date.getDate() + numDays);
  return newDate;
}

export function nextYear(month, year) {
  return month === 11 ? year + 1 : year;
}

export function nextMonth(month) {
  return (month + 1) % 12;
}

export function previousYear(month, year) {
  return month === 0 ? year - 1 : year;
}

export function previousMonth(month) {
  return month === 0 ? 11 : month - 1;
}

export function getDateTo(date, duration) {
  let dateTo = new Date(date);
  dateTo.setDate(date.getDate() + (duration - 1));
  return dateTo;
}
